const DEVICE_MODEL_IPAD = 'iPad';
export const mapUserDeviceOS = (userOS, deviceModel) => {
    if (!userOS)
        return null;
    const map = {
        iOS: 'iOS',
        Android: 'android',
    };
    if (deviceModel === DEVICE_MODEL_IPAD) {
        /**
         * Парсер UA считывает OS iPad как 'Mac OS',
         * по текущим требованиям в АО поведение на iPad должно соответствовать iOS
         */
        return 'iOS';
    }
    return map[userOS] || null;
};
